"use client";

import React, { useState } from 'react';
import axios from 'axios';
import Link from 'next/link';
const MAX_COUNT = 5;
import { useContext } from 'react';
import { AnalyticsContext } from '@/components/analytics/analytics-provider-app';

function objectToFormData(obj: Record<string, any>) {
  const formData = new FormData();
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          formData.append(`${key}[]`, value[i]);
        }
      } else {
        formData.append(key, value);
      }
    }
  }
  return formData;
}

export default function ContactUsForm() {
  const { visitedPages } = useContext(AnalyticsContext);

  const [honeypot, setHoneypot] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    website: '',
    deadline: 'Less than 10 working days',
    employees: '',
    hear_by: '',
    message: '',
  });

  const [uploadedFiles, setUploadedFiles] = useState<File[]>([])
  const [submited, setSubmited] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event) => {
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    if (honeypot) {
      alert('Please do not fill out the honeypot field');
      return;
    }

    event.preventDefault();
    setIsSubmitting(true);
    const formDataWithFiles = objectToFormData(formData);
    uploadedFiles.forEach((file) => {
      formDataWithFiles.append('attachments[]', file);
    });

    if(visitedPages.length > 0){
      formDataWithFiles.append('visitedPages', visitedPages.join(" -> "))
    }

    if(userAgent){
      formDataWithFiles.append('userAgent', userAgent)
    }
    
    axios
      .post(`${process.env.NEXT_PUBLIC_API_URL}/contact`, formDataWithFiles)
      .then((response) => {
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          website: '',
          deadline: 'Less than 10 working days',
          employees: '',
          hear_by: '',
          message: '',
        });
        setUploadedFiles([])
        setSubmited(true)
        setIsSubmitting(false);
      })
      .catch((error) => {
        console.error('Error sending message:', error);
        setIsSubmitting(false);
      });
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleUploadFiles = (files: File[]) => {
    const uploaded = [...uploadedFiles];
    let limitExceeded = false;
    files.some((file: File) => {
      if (uploaded.findIndex((f: any) => f.name === file.name) === -1) {
        uploaded.push(file);
        if (uploaded.length > MAX_COUNT) {
            alert(`You can only add a maximum of ${MAX_COUNT} files`);
            limitExceeded = true;
            return true;
        }
      }
    })
    if (!limitExceeded) setUploadedFiles(uploaded)
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (fileList) {
      const fileListArray = Array.from(fileList);
      handleUploadFiles(fileListArray);
    }
  };
  
  return (
    <>
      { !submited ? <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 gap-y-6 gap-x-8 sm:grid-cols-2">
          <div>
            <label htmlFor="name" className="block text-sm font-semibold leading-6 text-gray-900">
              Name*
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleChange}
                autoComplete="name"
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-semibold leading-6 text-gray-900">
              Email*
            </label>
            <div className="mt-2.5">
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                autoComplete="email"
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div>
            <label htmlFor="phone" className="block text-sm font-semibold leading-6 text-gray-900">
              Phone number*
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                id="phone"
                autoComplete="phone"
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div>
            <label htmlFor="company" className="block text-sm font-semibold leading-6 text-gray-900">
              Company Name*
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
                id="company"
                autoComplete="company"
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div>
            <label htmlFor="website" className="block text-sm font-semibold leading-6 text-gray-900">
              Website URL
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="website"
                value={formData.website}
                onChange={handleChange}
                id="website"
                autoComplete="website"
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div>
            <label htmlFor="deadline" className="block text-sm font-medium leading-6 text-gray-900">
              Deadline
            </label>
            <div className="mt-2.5">
              <select
                id="deadline"
                name="deadline"
                value={formData.deadline}
                onChange={handleChange}
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              >
                <option>Within 5 working days</option>
                <option>Less than 10 working days</option>
                <option>Less than 20 working days</option>
                <option>No hurry</option>
              </select>
            </div>
          </div>
          <div>
            <label htmlFor="employees" className="block text-sm font-medium leading-6 text-gray-900">
              Company size*
            </label>
            <div className="mt-2.5">
              <select
                id="employees"
                name="employees"
                value={formData.employees}
                onChange={handleChange}
                required
                autoComplete="employees"
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              >
                <option value="" disabled>Select your option</option>
                <option>1 to 10</option>
                <option>11 to 50</option>
                <option>51 to 200</option>
                <option>201 to 1,000</option>
                <option>1,001 or more</option>
              </select>
            </div>
          </div>
          <div>
            <label htmlFor="hear_by" className="block text-sm font-medium leading-6 text-gray-900">
              How did you hear about us?
            </label>
            <div className="mt-2.5">
              <select
                id="hear_by"
                name="hear_by"
                value={formData.hear_by}
                onChange={handleChange}
                autoComplete="hear_by"
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              >
                <option value="" disabled>Select your option</option>
                <option>Word of mouth</option>
                <option>Online search</option>
                <option>LinkedIn</option>
                <option>YouTube</option>
                <option>Facebook</option>
                <option>Blog</option>
                <option>Other</option>
              </select>
            </div>
          </div>
          <div>
            <label htmlFor="attachments" className="block text-sm font-semibold leading-6 text-gray-900">
              Attachments (optional)  
            </label>
            <label className="block mt-2.5">
              <span className="sr-only">Choose profile photo</span>
              <input type="file" 
                multiple
                onChange={handleFileChange}
                className="block w-full text-sm text-slate-500
                file:mr-4 file:py-2 file:px-4
                file:rounded-full file:border-0
                file:text-sm file:font-semibold
                file:bg-blue-50 file:text-blue-600
                hover:file:bg-blue-100
              "/>
            </label>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm font-semibold leading-6 text-gray-900">
              What do you need & how can we help? *
            </label>
            <div className="mt-2.5">
              <textarea
                name="message"
                id="message"
                rows={4}
                value={formData.message}
                onChange={handleChange}
                className="block w-full rounded-md border-0 py-2 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
        </div>
        <div className="hidden">
          <label htmlFor="honeypot">
            Honey Pot
          </label>
          <div className="mt-2.5">
            <input
              type="text"
              name="company"
              value={honeypot}
              onChange={(event) => setHoneypot(event.target.value)}
              id="honeypot"
              autoComplete="honeypot"
            />
          </div>
        </div>
        <div className="mt-8 flex justify-end">
          <button
            type="submit"
            disabled={isSubmitting}
            className={`rounded-md bg-blue-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 ${
              isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
            Send message
          </button>
        </div>
      </form> : 
        <div>
          <p className='mb-5 text-lg leading-8 text-gray-600'> Thank you for your message. We will get back to you shortly. </p>
          <Link
            href="/"
            className="rounded-md bg-blue-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            Home Page
          </Link>
        </div>
      }
    </>
  )
}
